<div class="oiq-layout-nav">
  <oiq-layout-nav-item
    [item]="item"
    *ngFor="let item of visibleItems; trackBy: trackByItem"
    [isSidebarExpanded]="isSidebarExpanded"
    [path]="path"
    [siblings]="visibleItems"></oiq-layout-nav-item>
</div>
